import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "getStartedContainer"
};
const _hoisted_2 = {
  class: "image speachesToValidate"
};
const _hoisted_3 = {
  class: "orangeCircle"
};
const _hoisted_4 = {
  class: "image speachesAwaitingValidation"
};
const _hoisted_5 = {
  class: "orangeCircle"
};
const _hoisted_6 = {
  class: "image notificationUnread"
};
const _hoisted_7 = {
  class: "orangeCircle"
};
const _hoisted_8 = {
  class: "image periodicReviews"
};
const _hoisted_9 = {
  class: "orangeCircle"
};
const _hoisted_10 = {
  class: "image periodicReviews"
};
const _hoisted_11 = {
  class: "orangeCircle"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_get_started_card = _resolveComponent("get-started-card");
  const _component_grid_layout = _resolveComponent("grid-layout");
  return _ctx.blockContainsAtLeastOneCard ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_grid_layout, null, {
    default: _withCtx(() => [_ctx.numberOfSpeachesToValidate > 0 ? (_openBlock(), _createBlock(_component_get_started_card, {
      key: 0,
      title: _ctx.$t('get.started.speachesToValidate.title', {
        numberOfSpeachesToValidate: _ctx.numberOfSpeachesToValidate
      }),
      content: _ctx.$t('get.started.speachesToValidate.content'),
      "button-label": _ctx.$t('get.started.speachesToValidate.button.label'),
      "close-button": false,
      onButtonClick: _cache[0] || (_cache[0] = $event => _ctx.navigate('/account/s/validate'))
    }, {
      icon: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.numberOfSpeachesToValidate), 1)])]),
      _: 1
    }, 8, ["title", "content", "button-label"])) : _createCommentVNode("", true), _ctx.numberOfSpeachesAwaitingValidation > 0 ? (_openBlock(), _createBlock(_component_get_started_card, {
      key: 1,
      title: _ctx.$t('get.started.speachesAwaitingValidation.title', {
        numberOfSpeachesAwaitingValidation: _ctx.numberOfSpeachesAwaitingValidation
      }),
      content: _ctx.$t('get.started.speachesAwaitingValidation.content'),
      "button-label": _ctx.$t('get.started.speachesAwaitingValidation.button.label'),
      "close-button": false,
      onButtonClick: _cache[1] || (_cache[1] = $event => _ctx.navigate('/account/s/validateInProgress'))
    }, {
      icon: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.numberOfSpeachesAwaitingValidation), 1)])]),
      _: 1
    }, 8, ["title", "content", "button-label"])) : _createCommentVNode("", true), _ctx.showCreateSpeachAICard ? (_openBlock(), _createBlock(_component_get_started_card, {
      key: 2,
      title: _ctx.$t('get.started.speach.generate.title'),
      content: _ctx.$t('get.started.speach.generate.content'),
      "button-label": _ctx.$t('get.started.speach.generate.button.label'),
      onButtonClick: _cache[2] || (_cache[2] = $event => _ctx.navigate('/recorder/aiSpeachGenerator')),
      "close-button": false
    }, {
      icon: _withCtx(() => _cache[9] || (_cache[9] = [_createElementVNode("div", {
        class: "image speachAI"
      }, null, -1)])),
      _: 1
    }, 8, ["title", "content", "button-label"])) : _createCommentVNode("", true), _ctx.mutableShowCreateSpeachCard ? (_openBlock(), _createBlock(_component_get_started_card, {
      key: 3,
      title: _ctx.$t('get.started.speach.title'),
      content: _ctx.$t('get.started.speach.content'),
      "button-label": _ctx.$t('get.started.speach.button.label'),
      onButtonClick: _cache[3] || (_cache[3] = $event => _ctx.navigate('/recorder/indexrecorderlayout')),
      "close-button": false
    }, {
      icon: _withCtx(() => _cache[10] || (_cache[10] = [_createElementVNode("div", {
        class: "image speach"
      }, null, -1)])),
      _: 1
    }, 8, ["title", "content", "button-label"])) : _createCommentVNode("", true), _ctx.mutableShowCreateUserCard ? (_openBlock(), _createBlock(_component_get_started_card, {
      key: 4,
      title: _ctx.$t('get.started.user.title'),
      content: _ctx.$t('get.started.user.content'),
      "button-label": _ctx.$t('get.started.user.button.label'),
      onButtonClick: _cache[4] || (_cache[4] = $event => _ctx.navigate('/administration/importUser')),
      onClose: _cache[5] || (_cache[5] = $event => _ctx.removeCreateUserCard())
    }, {
      icon: _withCtx(() => _cache[11] || (_cache[11] = [_createElementVNode("div", {
        class: "image user"
      }, null, -1)])),
      _: 1
    }, 8, ["title", "content", "button-label"])) : _createCommentVNode("", true), _ctx.numberOfUnreadNotification > 9 ? (_openBlock(), _createBlock(_component_get_started_card, {
      key: 5,
      "close-button": false,
      title: _ctx.$t('get.started.unread.notification.title', {
        numberOfUnreadNotification: _ctx.numberOfUnreadNotification
      }),
      content: _ctx.$t('get.started.unread.notification.content'),
      "button-label": _ctx.$t('get.started.unread.notification.button.label'),
      onButtonClick: _cache[6] || (_cache[6] = $event => _ctx.navigate('/account/myNotifications'))
    }, {
      icon: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.numberOfUnreadNotification), 1)])]),
      _: 1
    }, 8, ["title", "content", "button-label"])) : _createCommentVNode("", true), _ctx.numberOfPeriodicReviewsNearing > 1 ? (_openBlock(), _createBlock(_component_get_started_card, {
      key: 6,
      "close-button": false,
      title: _ctx.$t('get.started.periodicReviews.title', {
        numberOfPeriodicReviewsNearing: _ctx.numberOfPeriodicReviewsNearing
      }),
      content: _ctx.$t('get.started.periodicReviews.content'),
      "button-label": _ctx.$t('get.started.periodicReviews.button.label'),
      onButtonClick: _cache[7] || (_cache[7] = $event => _ctx.navigate('/admin.listspeach/listperiodicreviews'))
    }, {
      icon: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.numberOfPeriodicReviewsNearing), 1)])]),
      _: 1
    }, 8, ["title", "content", "button-label"])) : _createCommentVNode("", true), _ctx.numberOfSpeachesToReview > 1 ? (_openBlock(), _createBlock(_component_get_started_card, {
      key: 7,
      "close-button": false,
      title: _ctx.$t('get.started.speachesToReview.title', {
        numberOfSpeachesToReview: _ctx.numberOfSpeachesToReview
      }),
      content: _ctx.$t('get.started.speachesToReview.content'),
      "button-label": _ctx.$t('get.started.speachesToReview.button.label'),
      onButtonClick: _cache[8] || (_cache[8] = $event => _ctx.navigate('/account?tabSelected=TOREVIEW'))
    }, {
      icon: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.numberOfSpeachesToReview), 1)])]),
      _: 1
    }, 8, ["title", "content", "button-label"])) : _createCommentVNode("", true)]),
    _: 1
  })])) : _createCommentVNode("", true);
}